import i18nService from "../i18n";
export function useI18n() {
    const t = (key) => i18nService.t(key);
    const setLocale = (localeCode) => i18nService.setLocale(localeCode?.toLowerCase());
    const getLocale = () => i18nService.getLocale();
    const getLanguage = () => {
        const locale = i18nService.getLocale();
        const { code } = locale;
        return code.toUpperCase();
    };
    return {
        t,
        setLocale,
        getLocale,
        getLanguage
    };
}
